import React, {useContext} from "react"
import Text from "@amzn/meridian/text";
import {FormattedMessage} from "react-intl";
import Column from "@amzn/meridian/column";
import Box from "@amzn/meridian/box";
import Tooltip from "@amzn/meridian/tooltip";
import {CapabilityContext} from "../global/context/CapabilityContext";
import {getAveragePickDurationOfPicklists, getAveragePickTime} from "../util/Util";
import {useDeviceLayout} from "../common/context/DeviceLayoutContext";

const AveragePickDurationView = (props) => {
    const {configViewModel} = useContext(CapabilityContext);
    const {headerFont, textFont} = useDeviceLayout()

    const routeList = props.routes || [];
    const isParallelSite = configViewModel.stationConfig.parallelPickEnabled;

    const averagePickTime = {
        atRouteLevel: getAveragePickTime(routeList, configViewModel.stationConfig),
        atPicklistLevel: getAveragePickDurationOfPicklists(routeList, configViewModel.stationConfig)
    };

    const renderHeader = () => {
        if (configViewModel.stationConfig.parallelPickEnabled) {
            return <Tooltip position={"top"}
                title="Picklist level duration captures the time between assignment and last cart staged.
                            Route level duration sums up picklist cycle times.">
                <Column spacing={"none"} spacingInset={"none"}>
                    <Text type={headerFont}>
                        <b>
                            <FormattedMessage id="pickStatus.avgDuration" defaultMessage="Average Duration" />
                        </b>
                    </Text>
                    <Text type="b200">
                        <FormattedMessage id="pickStatus.routeOrPicklist" defaultMessage="Route/Picklist" />
                    </Text>
                </Column>
            </Tooltip>
        }
        return <Tooltip position={"top"} title="Total time spent picking all picklists for the route.">
            <Text type={headerFont}>
                <b>
                    <FormattedMessage id="pickStatus.avgPickDuration" defaultMessage="Avg. Pick Duration" />
                </b>
            </Text>
        </Tooltip>
    }

    return (
        <Box type="outline" spacingInset={"medium"}>
            <Column spacingInset={"none"} spacing={isParallelSite ? "small" : "medium"}>
                {/* HEADER */}
                {renderHeader()}

                <Column spacing="small">
                    {/* VALUE */}
                    <Text type="d50">
                        {averagePickTime.atRouteLevel.timeToShow}
                        {configViewModel.stationConfig.parallelPickEnabled ?
                            `/${averagePickTime.atPicklistLevel.timeToShow}`
                            : null
                        }
                    </Text>

                    {/* FOOTER */}
                    <Text data-footer type={textFont} color={"secondary"}>
                        {averagePickTime.atRouteLevel.unit}
                        {configViewModel.stationConfig.parallelPickEnabled ?
                            `/${averagePickTime.atPicklistLevel.unit}`
                            : null
                        }
                    </Text>
                </Column>
            </Column>
        </Box>
    )
}

export default AveragePickDurationView


// WEBPACK FOOTER //
// ./src/components/pickStatus/AveragePickDurationView.js